import React, { useState } from 'react';
import { Card } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { KeyIcon, ShieldIcon, MoonIcon, SunIcon } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
export function ImpostazioniUtente() {
  const {
    user
  } = useAuth();
  const [mfaEnabled, setMfaEnabled] = useState(false);
  const [theme, setTheme] = useState('classic');
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const handleMfaToggle = () => {
    setMfaEnabled(!mfaEnabled);
    // In un'implementazione reale, qui abiliteresti o disabiliteresti l'MFA
  };
  const handleThemeChange = (newTheme: string) => {
    setTheme(newTheme);
    // In un'implementazione reale, qui cambieresti il tema
  };
  return <div className="space-y-6 pb-16" data-id="element-2091">
      <div data-id="element-2092">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-2093">
          Impostazioni Utente
        </h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-2094">
          Gestisci le tue preferenze personali e impostazioni di sicurezza
        </p>
      </div>
      <Card data-id="element-2095">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-2096">
          Informazioni Personali
        </h2>
        <div className="space-y-4" data-id="element-2097">
          <div data-id="element-2098">
            <label className="block text-sm font-medium text-gray-700" data-id="element-2099">
              Nome
            </label>
            <div className="mt-1 p-2 bg-gray-50 border border-gray-300 rounded-md text-gray-500" data-id="element-2100">
              {user?.firstName || 'Mario'}
            </div>
          </div>
          <div data-id="element-2101">
            <label className="block text-sm font-medium text-gray-700" data-id="element-2102">
              Cognome
            </label>
            <div className="mt-1 p-2 bg-gray-50 border border-gray-300 rounded-md text-gray-500" data-id="element-2103">
              {user?.lastName || 'Rossi'}
            </div>
          </div>
          <div data-id="element-2104">
            <label className="block text-sm font-medium text-gray-700" data-id="element-2105">
              Email
            </label>
            <div className="mt-1 p-2 bg-gray-50 border border-gray-300 rounded-md text-gray-500" data-id="element-2106">
              {user?.email || 'mario.rossi@example.com'}
            </div>
          </div>
        </div>
      </Card>
      <Card data-id="element-2107">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-2108">Sicurezza</h2>
        <div className="space-y-4" data-id="element-2109">
          <div data-id="element-2110">
            <div className="flex justify-between items-center" data-id="element-2111">
              <div data-id="element-2112">
                <h3 className="text-sm font-medium text-gray-700" data-id="element-2113">Password</h3>
                <p className="mt-1 text-sm text-gray-500" data-id="element-2114">
                  Cambia la tua password per aumentare la sicurezza del tuo
                  account
                </p>
              </div>
              <Button variant="secondary" icon={<KeyIcon className="h-4 w-4 mr-2" data-id="element-2116" />} onClick={() => setShowPasswordModal(true)} data-id="element-2115">
                Cambia Password
              </Button>
            </div>
          </div>
          <div className="pt-4 border-t border-gray-200" data-id="element-2117">
            <div className="flex justify-between items-center" data-id="element-2118">
              <div data-id="element-2119">
                <h3 className="text-sm font-medium text-gray-700" data-id="element-2120">
                  Autenticazione a Due Fattori (MFA)
                </h3>
                <p className="mt-1 text-sm text-gray-500" data-id="element-2121">
                  Aggiungi un ulteriore livello di sicurezza al tuo account
                </p>
              </div>
              <div className="flex items-center" data-id="element-2122">
                <button type="button" className={`${mfaEnabled ? 'bg-[#1A3E5C]' : 'bg-gray-200'} relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-[#1A3E5C] focus:ring-offset-2`} role="switch" aria-checked={mfaEnabled} onClick={handleMfaToggle} data-id="element-2123">
                  <span className="sr-only" data-id="element-2124">Abilita MFA</span>
                  <span aria-hidden="true" className={`${mfaEnabled ? 'translate-x-5' : 'translate-x-0'} pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`} data-id="element-2125"></span>
                </button>
                <span className="ml-2 text-sm text-gray-500" data-id="element-2126">
                  {mfaEnabled ? 'Abilitato' : 'Disabilitato'}
                </span>
              </div>
            </div>
          </div>
        </div>
      </Card>
      <Card data-id="element-2127">
        <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-2128">Aspetto</h2>
        <div className="space-y-4" data-id="element-2129">
          <div data-id="element-2130">
            <h3 className="text-sm font-medium text-gray-700" data-id="element-2131">Tema</h3>
            <p className="mt-1 text-sm text-gray-500" data-id="element-2132">
              Scegli il tema dell'interfaccia
            </p>
            <div className="mt-4 grid grid-cols-2 gap-4" data-id="element-2133">
              <button type="button" className={`relative flex items-center justify-center p-4 rounded-lg border ${theme === 'classic' ? 'border-[#1A3E5C] bg-blue-50' : 'border-gray-300'}`} onClick={() => handleThemeChange('classic')} data-id="element-2134">
                <div className="flex flex-col items-center" data-id="element-2135">
                  <SunIcon className="h-6 w-6 text-[#1A3E5C]" data-id="element-2136" />
                  <span className="mt-2 text-sm font-medium text-gray-900" data-id="element-2137">
                    Classico
                  </span>
                </div>
                {theme === 'classic' && <span className="absolute top-2 right-2 h-4 w-4 rounded-full bg-[#1A3E5C]" data-id="element-2138">
                    <span className="absolute inset-0 flex items-center justify-center" data-id="element-2139">
                      <svg className="h-3 w-3 text-white" fill="currentColor" viewBox="0 0 12 12" data-id="element-2140">
                        <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" data-id="element-2141" />
                      </svg>
                    </span>
                  </span>}
              </button>
              <button type="button" className={`relative flex items-center justify-center p-4 rounded-lg border ${theme === 'dark' ? 'border-[#1A3E5C] bg-blue-50' : 'border-gray-300'}`} onClick={() => handleThemeChange('dark')} data-id="element-2142">
                <div className="flex flex-col items-center" data-id="element-2143">
                  <MoonIcon className="h-6 w-6 text-gray-600" data-id="element-2144" />
                  <span className="mt-2 text-sm font-medium text-gray-900" data-id="element-2145">
                    Scuro
                  </span>
                </div>
                {theme === 'dark' && <span className="absolute top-2 right-2 h-4 w-4 rounded-full bg-[#1A3E5C]" data-id="element-2146">
                    <span className="absolute inset-0 flex items-center justify-center" data-id="element-2147">
                      <svg className="h-3 w-3 text-white" fill="currentColor" viewBox="0 0 12 12" data-id="element-2148">
                        <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" data-id="element-2149" />
                      </svg>
                    </span>
                  </span>}
              </button>
            </div>
          </div>
        </div>
      </Card>
      {showPasswordModal && <div className="fixed inset-0 z-10 overflow-y-auto" data-id="element-2150">
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" data-id="element-2151">
            <div className="fixed inset-0 transition-opacity" aria-hidden="true" data-id="element-2152">
              <div className="absolute inset-0 bg-gray-500 opacity-75" data-id="element-2153"></div>
            </div>
            <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true" data-id="element-2154">
              &#8203;
            </span>
            <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6" data-id="element-2155">
              <div data-id="element-2156">
                <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-blue-100" data-id="element-2157">
                  <KeyIcon className="h-6 w-6 text-[#1A3E5C]" aria-hidden="true" data-id="element-2158" />
                </div>
                <div className="mt-3 text-center sm:mt-5" data-id="element-2159">
                  <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-2160">
                    Cambia Password
                  </h3>
                  <div className="mt-2" data-id="element-2161">
                    <p className="text-sm text-gray-500" data-id="element-2162">
                      Inserisci la tua password attuale e la nuova password che
                      desideri utilizzare.
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-5 sm:mt-6 space-y-4" data-id="element-2163">
                <div data-id="element-2164">
                  <label htmlFor="current-password" className="block text-sm font-medium text-gray-700" data-id="element-2165">
                    Password Attuale
                  </label>
                  <div className="mt-1" data-id="element-2166">
                    <input type="password" name="current-password" id="current-password" className="shadow-sm focus:ring-[#1A3E5C] focus:border-[#1A3E5C] block w-full sm:text-sm border-gray-300 rounded-md" placeholder="••••••••" data-id="element-2167" />
                  </div>
                </div>
                <div data-id="element-2168">
                  <label htmlFor="new-password" className="block text-sm font-medium text-gray-700" data-id="element-2169">
                    Nuova Password
                  </label>
                  <div className="mt-1" data-id="element-2170">
                    <input type="password" name="new-password" id="new-password" className="shadow-sm focus:ring-[#1A3E5C] focus:border-[#1A3E5C] block w-full sm:text-sm border-gray-300 rounded-md" placeholder="••••••••" data-id="element-2171" />
                  </div>
                </div>
                <div data-id="element-2172">
                  <label htmlFor="confirm-password" className="block text-sm font-medium text-gray-700" data-id="element-2173">
                    Conferma Nuova Password
                  </label>
                  <div className="mt-1" data-id="element-2174">
                    <input type="password" name="confirm-password" id="confirm-password" className="shadow-sm focus:ring-[#1A3E5C] focus:border-[#1A3E5C] block w-full sm:text-sm border-gray-300 rounded-md" placeholder="••••••••" data-id="element-2175" />
                  </div>
                </div>
                <div className="sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense" data-id="element-2176">
                  <button type="button" className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-[#1A3E5C] text-base font-medium text-white hover:bg-[#15324a] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1A3E5C] sm:col-start-2 sm:text-sm" data-id="element-2177">
                    Salva
                  </button>
                  <button type="button" className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1A3E5C] sm:mt-0 sm:col-start-1 sm:text-sm" onClick={() => setShowPasswordModal(false)} data-id="element-2178">
                    Annulla
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </div>;
}